import React, { useState, useEffect, useContext, useRef } from 'react';
import UserContext, { getUserDisplayName } from "../contexts/user.js";
import QuickLinks from './QuickLinks.js';

import '../styles/welcomeBanner.css';

const getDayTime = (hours) => {
    if(hours < 12) {
        return "morning";
    }
    if(hours < 18) {
        return "afternoon";
    }
    return "evening";
};

const WelcomeBanner = () => {
    const { userContext } = useContext(UserContext);

    const mainRef = useRef(null);
    const [mainHeight, setMainHeight] = useState(0);

    useEffect(() => {
        const node = mainRef.current;
        if(!node) {
            return;
        }

        const observer = new ResizeObserver(() => {
            setMainHeight(node.offsetHeight);
        });

        observer.observe(node);

        return () => observer.disconnect();
    }, []);

    const currentDate = new Date();
    const formatedDateString = currentDate.toLocaleDateString("en-GB", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    }).replace(/,/g, "");
    const dayTime = getDayTime(currentDate.getHours());

    return (
        <div
            className="welcome-banner"
            style={{
                "--main-height": `${mainHeight}px`
            }}
        >
            <div className="background"></div>

            <div className="main" ref={ mainRef }>
                <time dateTime={ currentDate }>{ formatedDateString }</time>
                <span className="hi">
                    Good { dayTime }, { getUserDisplayName(userContext) }
                </span>
                <span className="note">
                    Here&apos;s what is happening across the firm today
                </span>
            </div>

            <QuickLinks />
        </div>
    );
};

export default WelcomeBanner;
